import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { styled } from 'linaria/react';

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)``;

const SearchIcon = ({ className = '', ...rest }) => {
  return (
    <StyledFontAwesomeIcon icon={faSearch} {...rest} className={className} />
  );
};

export default SearchIcon;
